import { isNotNil } from '@wrisk/ui-components'
import { TFunction } from 'i18next'
import { range } from 'lodash-es'
import { DateTime } from 'luxon'

import { tDefaults, tEntries } from '../infrastructure/internationalisation'
import { VehicleKBA } from './types'

export const toVariantKBA = (vehicle: VehicleKBA) =>
  [vehicle.make, vehicle.variant].filter(isNotNil).join(' ')

export const toFullVariantKBA = (vehicle: VehicleKBA) =>
  `${toVariantKBA(vehicle)} (${toKBA(vehicle)})`

export const toManufactureRangeKBA = (vehicle: VehicleKBA) => {
  const currentYear = DateTime.local().year

  const start = vehicle.manufactureYearStart ?? currentYear
  const end = vehicle.manufactureYearStart ?? currentYear

  return range(start, end + 1)
}

export const toManufactureLabelKBA = (t: TFunction) => (vehicle: VehicleKBA) =>
  [
    vehicle.manufactureYearStart ?? 2026,
    vehicle.manufactureYearEnd ?? t(tDefaults('today')),
  ].join(' – ')

export const toKBA = (vehicle: VehicleKBA) =>
  [vehicle.hsn, vehicle.tsn].filter(isNotNil).join(' / ')

export const toPerformanceKBA = (vehicle: VehicleKBA) =>
  [
    vehicle.powerkW ? `${vehicle.powerkW} kW` : null,
    vehicle.powerPS ? `${vehicle.powerPS} PS` : null,
  ]
    .filter(isNotNil)
    .join(' / ') || null

export const toDisplacementKBA = (vehicle: VehicleKBA) =>
  vehicle.cubicCapacity ? `${vehicle.cubicCapacity} ccm` : null

export const toFuelTypeKBA = (t: TFunction) => (vehicle: VehicleKBA) =>
  vehicle.fuelType
    ? t(tEntries('fuelType', vehicle.fuelType), { defaultValue: vehicle.fuelType })
    : null
